import axios from "axios";
import {
  Button,
  FileUploader,
  Form,
  HtmlEditor,
  Menu,
  Popup,
} from "devextreme-react";
import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { updateEmployeeNo } from "./Redux/userInfo";

import { notifyMsg } from "./notify";

import { ReactComponent as SBeccoCRO } from "./BeccoCRO_logo.svg";

import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import { Toolbar } from "devextreme-react/html-editor";
import { Item } from "devextreme-react/toolbar";
import { Link, useNavigate } from "react-router-dom";
import { menuList } from "./data";
import "./index.css";
import { useContext } from "react";
import { AuthStateContext } from "../../AuthContext";

export default function Header(props) {
  const { title, menuDataSource, setCMenu } = props;

  console.debug("menuDataSource", menuDataSource);

  const [popupVisible, setPopupVisible] = useState(false);
  const { setAuthState } = useContext(AuthStateContext);

  const formLoginRef = useRef(null);
  const formChangePasswordRef = useRef(null);
  const timerId = useRef(null);
  const menuRef = useRef(null);

  const formBugReportRef = useRef(null);
  const descriptionRef = useRef(null);
  const fileUploaderRef = useRef(null);
  const userIdRef = useRef(null);

  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);

  const selectedDoc = useSelector((state) => state.SOPViewer.selectedDoc);

  const navigate = useNavigate();

  useEffect(() => {
    userIdRef.current = userInfo.id;
  }, [userInfo.id]);

  useEffect(() => {
    const autoLogout = () => {
      if (document.visibilityState === "hidden") {
        // set timer to log user out
        const id = window.setTimeout(() => {
          onClickCard();
        }, 10 * 60 * 1000);
        timerId.current = id;
      } else {
        // clear existing timer
        window.clearTimeout(timerId.current);
      }
    };

    document.addEventListener("visibilitychange", autoLogout);

    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();

      if (userIdRef.current) {
        axios.put(
          `${process.env.REACT_APP_BECCO_API_URL}/api/common/login/acsLog/${userIdRef.current}`
        );
      }

      dispatch(updateEmployeeNo(null));
    });

    return () => {
      // window.removeEventListener("beforeunload", handleTabClose);
      document.removeEventListener("visibilitychange", autoLogout);
    };
  }, []);

  useEffect(() => {
    const handleTabClose = (event) => {
      event.preventDefault();

      if (window.location.pathname == "/SOPViewer") {
        if (selectedDoc) {
          axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${userInfo.employeeNo}`
          );
        }

        return;
      } else {
        return;
      }
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, [selectedDoc]);

  const onClickLogout = async () => {
    dispatch(updateEmployeeNo(null));
    setAuthState({ checked: true, authenticated: false });
    await axios.post(`${process.env.REACT_APP_BECCO_API_URL}/api/common/auth/logout`);
    notifyMsg("로그아웃 되었습니다", "success");
  };

  const onClickCard = async () => {
    if (userInfo.employeeNo) {
      if (window.location.pathname == "/SOPViewer") {
        if (selectedDoc) {
          axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${userInfo.employeeNo}`
          );
        }
      }

      axios.put(
        `${process.env.REACT_APP_BECCO_API_URL}/api/common/login/acsLog/${userInfo.id}`
      );

      dispatch(updateEmployeeNo(null));
      setAuthState({ checked: true, authenticated: false });
      await axios.post(`${process.env.REACT_APP_BECCO_API_URL}/api/common/auth/logout`);
      notifyMsg("로그아웃 되었습니다", "success");
    } else {
      navigate("/");
    }
  };

  const onItemClick = (e) => {
    setCMenu(e.itemData.id);

    menuRef.current.instance.selectItem(e.itemElement);
  };

  const onHiding = () => {
    setPopupVisible(false);

    formBugReportRef.current.instance.resetValues();
    descriptionRef.current.instance.reset();
  };

  const onShown = (e) => {
    formBugReportRef.current.instance.getEditor("menu").focus();
  };

  const onClick = async () => {
    const descrValue = descriptionRef.current.instance.option("value");

    if (formBugReportRef.current.instance.validate().isValid) {
      if (descrValue) {
        try {
          const result = await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/common/bugRpt`,
            {
              menu: formBugReportRef.current.instance.option("formData").menu,
              descr: descrValue,
              employeeNo: userInfo.employeeNo,
            }
          );

          fileUploaderRef.current.instance.option(
            "uploadUrl",
            `${process.env.REACT_APP_BECCO_API_URL}/api/common/bugRpt/${result.data}`
          );

          fileUploaderRef.current.instance.upload();

          setPopupVisible(false);

          formBugReportRef.current.instance.option("formData", null);
          descriptionRef.current.instance.option("value", null);
          fileUploaderRef.current.instance.reset();

          notifyMsg("문의가 전달되었습니다.", "success");
        } catch (error) {
          console.error(error);
        }
      } else {
        notifyMsg("Description을 입력해주세요.", "error");
      }
    }
  };

  const onRightMenuItemClick = (e) => {
    if (e.itemData.id == "bugReport") {
      navigate("/qna");
      // setPopupVisible(true);
    } else if (e.itemData.id == "logout") {
      onClickCard();
    } else if (e.itemData.id == "relNotes") {
      navigate("/RelNotes");
    } else if (e.itemData.id == "manual") {
      window.open("https://beccocro.gitbook.io/manual/", "_blank");
    }
  };

  return (
    <React.Fragment>
      <header style={{ borderBottom: "3px solid #007048" }}>
        <div style={{ marginLeft: "18px", marginTop: "10px" }}>
          <Link to={"/"}>
            <SBeccoCRO width={101.94} height={40} viewBox="0 0 110 40" />
          </Link>
          <h1
            style={{
              color: "#007048",
              marginBlockStart: "0.67em",
              marginBlockEnd: "0.67em",
              marginInlineStart: "0px",
              marginInlineEnd: "0px",
              display: "inline-block",
              marginLeft: "10px",
              marginTop: "7px",
              verticalAlign: "top",
              // float: "left",
            }}
          >
            {title}
          </h1>
          <div className="menu">
            <Menu
              id="menu"
              keyExpr={"id"}
              ref={menuRef}
              dataSource={menuDataSource}
              displayExpr="name"
              orientation="horizontal"
              onItemClick={onItemClick}
            />
          </div>
          <div style={{ float: "right", marginRight: "10px" }}>
            <Menu
              id="rightMenu"
              keyExpr={"id"}
              displayExpr="name"
              visible={userInfo.employeeNo ? true : false}
              items={[
                {
                  id: "help",
                  icon: "help",
                  items: [
                    {
                      id: "relNotes",
                      name: "Release Notes",
                    },
                    {
                      id: "manual",
                      name: "Manual",
                    },
                    {
                      id: "bugReport",
                      name: "문의하기",
                    },
                  ],
                },
                {
                  id: "name",
                  name: `${userInfo.enName ? userInfo.enName : userInfo.name}`,
                },
                {
                  id: "image",
                  icon: `${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${userInfo.employeeNo}`,
                  items: [
                    {
                      id: "logout",
                      name: "Logout",
                    },
                  ],
                },
              ]}
              onItemClick={onRightMenuItemClick}
            />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
}
